export enum UserInfoAction {
  SET_LOADING = '[userInfo] SET_LOADING',
  ERROR_SIGNIN = '[userInfo] ERROR_SIGNIN',
  SIGN_IN = '[userInfo] SIGN_IN',
  CLEAR_ERROR = '[userInfo] CLEAR_ERROR',
  SIGN_OUT = '[userInfo] SIGN_OUT'
}
